export default "__VITE_ASSET__54580280__"